module.exports = __webpack_public_path__ + "img/17-8.8700125c.jpg";